import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import QuestionSection from "../../ui/QuestionSection/QuestionSection";
import CommonFooter from "../../CommonFooter/CommonFooter";
import CommonButton from "../../ui/CommonButton/CommonButton";
import classes from "./ReportsRequirements.module.css";
import { useAccreditation } from "../../../hooks/useAccreditation";

const ReportsRequirements = () => {
  const { labId } = useParams();
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [currentSet, setCurrentSet] = useState(0);
  const [isEditing, setIsEditing] = useState(false);

  const { formData, setFormData, loading, hydrated, fetching, editable, setEditable, handleDone } =
    useAccreditation({
      labId,
      section: "Reports requirements",
      name: "SADCAS F134-B",
      auditorId: user._id,
      isAssessor: user.role === "ASSESSOR",
      isEditing,
      token,
    });

  const handleAnswerChange = (questionId, score, comment, points, content) => {
    setFormData((prev) => ({
      ...prev,
      [questionId]: { score, comment, points, content },
    }));
  };

  const questionSets = [
    {
      questions1: [
        {
          questionId: "Q1",
          content:
            "a. Unique patient Identification, date of primary sample, type of primary sample collection and date of report on each page of report.",
          number: "7.4.1.6 (a,d)",
          multiline: true,
          placeholder: "Add comment",
          hideOptions: true,
        },
        {
          questionId: "Q2",
          content:
            "b. Clear, unambiguous identification of the examinations performed and the examination method used.",
          number: "7.4.1.6 (e,f)",
          multiline: true,
          placeholder: "Add comment",
          hideOptions: true,
        },
        {
          questionId: "Q3",
          content:
            "c. Indication of any critical results, notification of user or authorised personnel as soon as relevant, and escalation procedure for laboratory personnel when responsible person cannot be contacted.",
          number: "7.4.1.6 (i) & 7.4.1.3",
          multiline: true,
          placeholder: "Add comment",
          hideOptions: true,
        },
        {
          questionId: "Q4",
          content:
            "d. Examination results with reported in SI units or other applicable units and indication of biological reference.",
          number: "7.4.1.6 (g,h)",
          multiline: true,
          placeholder: "Add comment",
          hideOptions: true,
        },
        {
          questionId: "Q5",
          content:
            "e. Identification of the person(s) reviewing the results and authorizing the release of the report (if not contained in the report, readily available when needed)",
          number: "7.4.1.6 (j)",
          multiline: true,
          placeholder: "Add comment",
          hideOptions: true,
        },
        {
          questionId: "Q6",
          content:
            "f. Are examination results reported accurately, clearly, unambiguously and in accordance with any specific instructions in the examination procedure?",
          number: "7.4.1.1 (a)",
          multiline: true,
          placeholder: "Add comment",
          hideOptions: true,
        },
        {
          questionId: "Q7",
          content:
            "g. Is all information associated with issued reports retained in accordance with management system requirements?",
          number: "8.4",
          multiline: true,
          placeholder: "Add comment",
          hideOptions: true,
        },
        {
          questionId: "Q8",
          content:
            "h. Is this a revised report? If yes, is it clearly identified as a revision and includes reference to the date and patient’s identity in the original",
          number: "7.4.1.8",
          multiline: true,
          placeholder: "Add comment",
          hideOptions: true,
        },
      ],
      questions2: [
        {
          questionId: "Comment1",
          multiline: true,
          placeholder: "Add comment",
          hideOptions: true,
        },
      ],
      render: (onAnswerChange, answers) => (
        <>
          <QuestionSection
            topQuestion={false}
            accreditation
            addWidth
            showPointsField={false}
            questions={questionSets[0].questions1}
            onAnswerChange={editable ? onAnswerChange : () => {}}
            answers={answers}
            disabled={!editable}
          />
          <QuestionSection
            topQuestion={false}
            showQuestion={false}
            showEmptyNumber={false}
            accreditation
            showPointsField={false}
            questions={questionSets[0].questions2}
            onAnswerChange={editable ? onAnswerChange : () => {}}
            answers={answers}
            disabled={!editable}
          />
        </>
      ),
    },
  ];

  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet((prev) => prev + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet((prev) => prev - 1);
  };

  if (!hydrated || fetching) {
    return <div className={classes.loading}>Loading...</div>;
  }

  return (
    <div className={`${classes.wrapper} ${!editable ? classes.fromParams : ""}`}>
      <div className="d-flex justify-content-between align-items-center">
        <div
          className="d-flex align-items-center gap-2 mb-4"
          onClick={() => navigate(-1)}
          role="button"
        >
          <IoIosArrowRoundBack size={35} />
          <h2 className="m-0">Clause 7.4.1.6: Requirements for reports</h2>
        </div>
        {user.role === "ASSESSOR" && !editable && (
          <CommonButton
            className={classes.editButton}
            onClick={() => {
              setIsEditing(true);
              setEditable(true);
            }}
            title="Edit"
          />
        )}
      </div>

      {!editable ? (
        <div className={classes.infoText}>
          ✅ Your SADCAS B - Clause 7.4.1.6: Requirements for reports has been submitted.
        </div>
      ) : (
        questionSets[currentSet].render(handleAnswerChange, formData)
      )}

      {editable && (
        <CommonFooter
          handlePrevious={handlePrevious}
          handleNext={handleNext}
          handleDone={handleDone}
          cancelText="Cancel"
          handleCancel={() => setEditable(false)}
          currentSet={currentSet}
          questionSets={questionSets}
          doneText={loading ? "Submitting..." : "Update"}
          disabled={loading}
        />
      )}
    </div>
  );
};

export default ReportsRequirements;